import { render, staticRenderFns } from "./p1.vue?vue&type=template&id=70732ad0&scoped=true&"
import script from "./p1.vue?vue&type=script&lang=js&"
export * from "./p1.vue?vue&type=script&lang=js&"
import style0 from "./p1.vue?vue&type=style&index=0&id=70732ad0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70732ad0",
  null
  
)

export default component.exports